import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { PatientData } from "../offline-asmt-data-service/offline-asmt-data-interface";
import { DatabaseProvider } from "../offline-database/db-connection";
import { DbQueries } from "../offline-database/db-queries";
import {
  SQLiteProgress,
  stringifyJSON,
} from "../offline-manager/offline-globals";

@Injectable()
export class PatientDataManager {
  constructor(public database: DatabaseProvider, public events: Events) {}

  public dumpAllPatients(
    patientArr: PatientData[],
    clearPreviousRecords: boolean = true
  ): any {
    this.database.getInstance().subscribe(
      (db) => {
        db.transaction(
          (tx) => {
            if (clearPreviousRecords) {
              tx.executeSql(DbQueries.PATIENT_CLEAR);
            }

            for (let patient of patientArr) {
              this.dumpPatientData(patient, tx);
            }
          },
          (error) => {
            console.log("dumpAllPatients transaction error: " + error.message);
          },
          () => {
            console.log("dumpAllPatients transaction ok");
          }
        );
      },
      (error) => {
        console.log("dumpAllPatients.getInstance error: " + error.message);
      }
    );
  }

  public dumpPatientData(patient: PatientData, tx: any): any {
    let {
      chartId,
      userId,
      patientFullName,
      dateOfBirth,
      age,
      primaryDiagnosis,
      secondaryDiagnosis,
      levelOfCare,
      codeStatus,
      careTeam,
      caseManagerFullName,
      certifyingPhysicianFullame,
      nursePractitioner,
      attendingPhysicianFullName,
      medicalDirectorFullName,
      careLocationType,
      careLocationAddress1,
      careLocationCity,
      careLocationState,
      careLocationZip,
      primaryCareGiverFullName,
      primaryCareGiverPhoneNumber,
      riskPriority,
      patientGender,
      benefitPeriod,
      foodAllergies,
      drugAllergies,
      dareStatus,
    } = patient;

    tx.executeSql(DbQueries.PATIENT_INSERT, [
      chartId,
      userId,
      patientFullName,
      dateOfBirth,
      age,
      primaryDiagnosis,
      secondaryDiagnosis,
      levelOfCare,
      codeStatus,
      careTeam,
      caseManagerFullName,
      certifyingPhysicianFullame,
      nursePractitioner,
      attendingPhysicianFullName,
      medicalDirectorFullName,
      careLocationType,
      careLocationAddress1,
      careLocationCity,
      careLocationState,
      careLocationZip,
      primaryCareGiverFullName,
      primaryCareGiverPhoneNumber,
      riskPriority,
      patientGender,
      benefitPeriod,
      foodAllergies,
      drugAllergies,
      dareStatus,
    ]);
  }

  dumpAllTemplateReplacementData(replacements) {
    this.database.getInstance().subscribe(
      (db) => {
        db.transaction(
          (tx) => {
            for (let replacement of replacements) {
              tx.executeSql(DbQueries.TEMPLATE_REPLACEMENT_DATA_INSERT, [
                replacement.patientId,
                stringifyJSON(replacement.GET_FAMILY_CONTACTS),
                stringifyJSON(replacement.GET_LPN_CONTACTS),
                stringifyJSON(replacement.GET_HHA_CONTACTS),
                stringifyJSON(replacement.GET_PHYSICIAN_LIST),
              ]);
            }
          },
          (error) => {
            console.log(
              "dumpAllTemplateReplacementData transaction error: " +
                error.message
            );
          },
          () => {
            console.log("dumpAllTemplateReplacementData transaction ok");
            this.events.publish("onSQLiteProgress", SQLiteProgress.Finished);
          }
        );
      },
      (error) => {
        console.log(
          "dumpAllTemplateReplacementData.getInstance error: " + error.message
        );
      }
    );
  }

  createUnplannedPatient(patient): Observable<any> {
    return new Observable((observer) => {
      this.database.getInstance().subscribe((db) => {
        db.transaction((tx) => {
          let { chartId, userId, patientFullName, levelOfCare, patientGender } =
            patient;
          tx.executeSql(
            DbQueries.UNPLANNED_PATIENT_INSERT,
            [chartId, userId, patientFullName, levelOfCare, patientGender],
            () => {
              observer.next();
            },
            (_, error) => {
              console.log("Create unplanned Patient error: " + error.message);
              observer.error(error);
            },
            () => {
              observer.complete();
            }
          );
        });
      });
    });
  }

  getPatientOfflineData(userId): Observable<any> {
    return new Observable((observer) => {
      this.database.getInstance().subscribe((db) => {
        db.transaction((tx) => {
          tx.executeSql(
            DbQueries.SELECT_PATIENT_DATA,
            [userId],
            (tx, rs) => {
              let data = {
                patients: [],
                count: rs.rows.length,
              };
              for (var x = 0; x < rs.rows.length; x++) {
                data.patients.push(rs.rows.item(x));
              }
              observer.next(data);
            },
            (_, error) => {
              console.log("SELECT Patient TYPE error: " + error.message);
              observer.error(error);
            },
            () => {
              observer.complete();
            }
          );
        });
      });
    });
  }

  public getPatientProfile(patientId: number): Observable<any> {
    return new Observable((observer) => {
      this.database.getInstance().subscribe(
        (db) => {
          db.transaction(
            (tx) => {
              tx.executeSql(
                DbQueries.PROFILE_SELECT_BY_PATIENT,
                [patientId],
                (tx, resultSet) => {
                  var data = {};
                  if (resultSet.rows.length > 0) {
                    data = resultSet.rows.item(0);
                  }
                  observer.next(data);
                },
                (tx, error) => {
                  console.log(
                    "SELECT error (getPatientProfile): " + error.message
                  );
                }
              );
            },
            (error) => {
              console.log(
                "Transaction ERROR (getPatientProfile): " + error.message
              );
              observer.error(error);
              observer.complete();
            },
            () => {
              console.log("Transaction ok (getPatientProfile)");
              observer.complete();
            }
          );
        },
        (error) => {
          console.log("getPatientProfile.getInstance error: " + error.message);
          observer.complete();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/offline-manager/patient-data-manager.ts